import React from 'react';

import { Route, Switch, useRouteMatch } from 'react-router-dom';

import DataPage from './DataPage';

const DataRoutes: React.FC = () => {
    const { path } = useRouteMatch();

    console.log('DataRoutes path', path);
    return (
        <>
            <Switch>
                <Route exact path={`${path}`} component={DataPage} />
            </Switch>
        </>
    );
};

export default DataRoutes;
